import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ICityResponse,
  ICreateCityRequest,
  IUpdateCityReqeust,
} from '../dtos';
import { LocationManagementCollections } from '../../common/collections';
import { CollectionApiClient, IPaginationResponse, ISoftDeletablePaginationParameters } from '../../../data-access';
import { ICreateCityResponse } from '../dtos/responses/create.city.response';
import { ICitiesApiClient } from './i-cities-api.client';

@Injectable({
  providedIn: 'root'
})
export class CitiesApiClient implements ICitiesApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(
      LocationManagementCollections.Cities,
      http
    );
  }

  get(
          paginationParameters?: ISoftDeletablePaginationParameters
  ): Observable<IPaginationResponse<ICityResponse>> {
    return this.collectionApiClient.get({
      paginationParameters
    });
  }

  getById(id: string): Observable<ICityResponse> {
    return this.collectionApiClient.get({
      id
    });
  }

  create(request: ICreateCityRequest): Observable<ICreateCityResponse> {
    return this.collectionApiClient.post({
      body: request
    });
  }

  update(id: string, request: IUpdateCityReqeust): Observable<void> {
    return this.collectionApiClient.put({
      id,
      body: request
    });
  }

  getDistricts(
    cityId: string,
    paginationParameters?: ISoftDeletablePaginationParameters
  ): Observable<IPaginationResponse<ICityResponse>> {
    return this.collectionApiClient.get({
      collectionName: LocationManagementCollections.cityDistricts(cityId),
      paginationParameters
    });
  }
}
